import { datadogLogger } from "../datadog";

type FetchInputProps<TRequest> = {
  url: string;
  data: TRequest;
};

export const fetchData = async <TRequest, TResponse>(
  props: FetchInputProps<TRequest>,
): Promise<TResponse> => {
  const { url, data } = props;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      datadogLogger.error("Fetch failure", {
        url,
        status: response.status,
        statusText: response.statusText,
      });
      throw new Error("HTTP-Fehler: " + response.status);
    }

    return (await response.json()) as TResponse;
  } catch (error) {
    if (error instanceof Error) {
      // Don't log again if we already logged it above (though we re-throw)
      if (error.message.startsWith("HTTP-Fehler")) {
        throw error;
      }

      datadogLogger.error("Fetch exception (e.g. CORS or Network)", {
        url,
        errorMessage: error.message,
        errorName: error.name,
      });
    } else {
      datadogLogger.error("Fetch unknown error", { url, error: String(error) });
    }
    throw error;
  }
};
